<template src="./Services.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      services: [],
      popupService: false,
      serviceId: null,
      serviceName: null,
      invalidServiceName: false,
      invalidZone: false,
      active: true,
      zones: [],
      zone: null,
      popupPermissions: false,
      zoneOne: null,
      zoneTwo: null,
      zoneThree: null,
      invalidFields: {
        zoneOne: false,
        zoneTwo: false,
        zoneThree: false
      },
      saveClicked: false,
      titleModalServiceRegister: "",
      search: "",
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
    };
  },
  watch: {
    serviceName: function (newVal) {
      const vm = this;
      vm.invalidServiceName = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    zone: function (newVal) {
      const vm = this;
      vm.invalidZone = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    zoneOne: function() {
      const vm = this;
      vm.validatePermissionsDays();
    },
    zoneTwo: function() {
      const vm = this;
      vm.validatePermissionsDays();
    },
    zoneThree: function() {
      const vm = this;
      vm.validatePermissionsDays();
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    init() {
      const vm = this;
      vm.getServicesList();
      vm.getZones();
    },
    newService() {
      const vm = this;
      vm.titleModalServiceRegister = "Novo serviço";
      vm.clearServiceFields();
      vm.popupService = true;
    },
    getServicesList() {
      const vm = this;
      const page = vm.currentx - 1;
      const search = vm.testNullUndefinedEmpty(vm.search) ? "" : "&search=" + vm.search;
      vm.$vs.loading();
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(vm.$store.state.filooServer +
        "consultant/rotasCliente?page=" + page  + "&size=10&sort=id,desc"+ search)
        .then(function (response) {
          if (response.status === 200) {
            vm.services = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
          }
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },
    getZones() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(vm.$store.state.filooServer + "consultant/defaultLane")
        .then(function (response) {
          if (response.status === 200) {
            vm.zones = response.data;
            for (let z in vm.zones) {
              let id = parseInt(z) + 1;
              vm.zones[z].id = id;
              vm.zones[z].text =
                "Zona " + id + " - " + vm.zones[z].value + " dias";
            }
          }
        });
    },
    validateFields() {
      const vm = this;
      vm.saveClicked = true;
      vm.invalidServiceName = vm.testNullUndefinedEmpty(vm.serviceName);
      vm.invalidZone = vm.testNullUndefinedEmpty(vm.zone);

      if (!vm.invalidServiceName && !vm.invalidZone) {
        vm.testNullUndefinedEmpty(vm.serviceId) ?
          vm.postNewService()
          :vm.putService();
      }
    },
    postNewService() {
      const vm = this;
      let service = {
        active: vm.active,
        rota: vm.serviceName,
        faixa: vm.zone.id,
      };
      vm.axios
        .post(
          vm.$store.state.filooServer + "consultant/rotasCliente",
          service,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.popupService = false;
            vm.search = "";
            vm.currentx = 0
            vm.$swal(
              "Operação realizada!",
              "O serviço <b style='color: #FF9F43; font-weight: 500'>" +
                vm.serviceName +
                "</b> foi adicionado com sucesso.",
              "success"
            );
            vm.$nextTick(() => {
              vm.getServicesList();
            });
          }
        })
        .catch(function () {
          vm.popupService = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar a operação, contacte o administrador do sistema.",
            icon: "error",
          });
        })
        .finally(() => {
          vm.saveClicked = false;
        });
    },

    putService(isStatus) {
      const vm = this;
      let service = {
        id: vm.serviceId,
        active: vm.active,
        rota: vm.serviceName,
        faixa: vm.zone.id,
      };
      vm.axios
        .put(vm.$store.state.filooServer + "consultant/rotasCliente", service, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupService = false;
            if(isStatus) {
              vm.$nextTick(() => {
                vm.removeFocus();
              });
            } else {
              vm.$swal(
              "Operação realizada!",
              "O serviço <b style='color: #FF9F43; font-weight: 500'>" +
                vm.serviceName +
                "</b> foi alterado com sucesso.",
              "success"
              );
            }
            vm.$nextTick(() => {
              vm.getServicesList();
            });
          }
        })
        .catch(function () {
          vm.popupService = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar a operação, contacte o administrador do sistema.",
            icon: "error",
          });
        })
        .finally(() => {
          vm.saveClicked = false;
        });
    },
    editService(service) {
      const vm = this;
      vm.clearServiceFields();
      vm.serviceName = service.rota;
      vm.serviceId = service.id;
      vm.zone = vm.zones.find(s => {return s.id === service.faixa;});
      vm.active = service.active;
      vm.titleModalServiceRegister = "Editar serviço";
      vm.popupService = true;
    },

    changeStatus(service) {
      const vm = this;
      vm.serviceId = service.id;
      vm.active = !service.active;
      vm.serviceName = service.rota;
      vm.zone = vm.zones.find(s => {return s.id === service.faixa;});
      vm.putService(true);
    },

    clearServiceFields() {
      const vm = this;
      vm.serviceName = null;
      vm.serviceId = null;
      vm.zone = null;
      vm.active = true;
      vm.invalidServiceName = false;
      vm.invalidZone = false;
    },
    managePermissions() {
      const vm = this;
      vm.zoneOne = vm.zones[0].value;
      vm.zoneTwo = vm.zones[1].value;
      vm.zoneThree = vm.zones[2].value;
      vm.popupPermissions = true;
    },
    clearInvalidFieldsPopupPermissions() {
      const vm = this;
      vm.invalidFields.zoneOne = false;
      vm.invalidFields.zoneTwo = false;
      vm.invalidFields.zoneThree = false;
    },

    validatePermissionsDays() {
      const vm = this;
      vm.clearInvalidFieldsPopupPermissions();

      vm.invalidFields.zoneOne = !(parseInt(vm.zoneOne) < parseInt(vm.zoneTwo)) 
        !(parseInt(vm.zoneOne) < parseInt(vm.zoneThree)) ||
        vm.testNullUndefinedEmpty(vm.zoneOne);

      vm.invalidFields.zoneTwo = !(parseInt(vm.zoneTwo) < parseInt(vm.zoneThree)) ||
        vm.testNullUndefinedEmpty(vm.zoneTwo);

      vm.invalidFields.zoneThree = !(parseInt(vm.zoneTwo) < parseInt(vm.zoneThree)) ||
      !(parseInt(vm.zoneTwo) < parseInt(vm.zoneThree)) ||
      vm.testNullUndefinedEmpty(vm.zoneThree);
    },

    saveChangesPermissionsDays() {
      const vm = this;
      if (!vm.invalidFields.zoneOne && !vm.invalidFields.zoneTwo && !vm.invalidFields.zoneThree) 
      {
        vm.axios
          .put(
            vm.$store.state.filooServer +
              "consultant/defaultLane/" +
              vm.zoneOne +
              "/" +
              vm.zoneTwo +
              "/" +
              vm.zoneThree,
            {
              headers: { Authorization: vm.$session.get("bearerDefault") },
            }
          )
          .then(function (response) {
            if (response.status === 200) {
              vm.popupPermissions = false;
              vm.$swal(
                "Operação realizada!",
                "Os dias das <b style='color: #FF9F43; font-weight: 500'> faixas (1, 2 e 3)</b> foram alteradas com sucesso.",
                "success"
              );
              vm.$nextTick(() => {
                vm.getZones();
              });
            }
          })
          .catch(function () {
            vm.popupPermissions = false;
            vm.$swal({
              title: "Atenção!",
              text:
                "Não foi possível realizar a operação, contacte o administrador do sistema.",
              icon: "error",
            });
          });
      }
    },
    removeFocus() {
      document.activeElement.blur()
    },

    changeSearch(){
      const vm = this;
      vm.currentx = 0;
      vm.$vs.loading();
      vm.getServicesList();
    },
    changePagination(){
      const vm = this;
      vm.getServicesList();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" src="./Services.scss">
</style>